// src/pages/produccion/TiempoMuerto.jsx
import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../services/api';

const LINEAS = ['Granola', 'Barras'];
const AREAS = ['Mezclado', 'Horneado', 'Empaque'];
const TURNOS = ['Matutino', 'Nocturno'];
const META = 0.5; // % — según la ficha del KPI

const MESES = [
  ['01', 'Enero'], ['02', 'Febrero'], ['03', 'Marzo'], ['04', 'Abril'], ['05', 'Mayo'], ['06', 'Junio'],
  ['07', 'Julio'], ['08', 'Agosto'], ['09', 'Septiembre'], ['10', 'Octubre'], ['11', 'Noviembre'], ['12', 'Diciembre'],
];
function ultimoDiaDelMes(anio, mes) {
  return new Date(anio, parseInt(mes), 0).getDate();
}

export default function TiempoMuerto() {
  const [registros, setRegistros] = useState([]);
  const [topCausas, setTopCausas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const [fDesde, setFDesde] = useState('');
  const [fHasta, setFHasta] = useState('');
  const [fMes, setFMes] = useState('');
  const [fAnio, setFAnio] = useState(new Date().getFullYear());
  const [fLinea, setFLinea] = useState('');
  const [fArea, setFArea] = useState('');
  const [fTurno, setFTurno] = useState('');

  async function cargar() {
    try {
      setCargando(true);
      const params = {};
      if (fDesde) params.desde = fDesde;
      if (fHasta) params.hasta = fHasta;
      if (fLinea) params.linea = fLinea;
      if (fArea) params.area = fArea;
      if (fTurno) params.turno = fTurno;
      const res = await api.get('/api/produccion/tiempo-muerto-resumen', { params });
      setRegistros(res.data.data);
      setTopCausas(res.data.topCausas);
      setError(null);
    } catch (err) {
      console.error(err);
      setError('No se pudo cargar el resumen.');
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleMesChange(mes) {
    setFMes(mes);
    if (mes) {
      setFDesde(`${fAnio}-${mes}-01`);
      setFHasta(`${fAnio}-${mes}-${String(ultimoDiaDelMes(fAnio, mes)).padStart(2, '0')}`);
    }
  }
  function limpiarFiltros() {
    setFDesde(''); setFHasta(''); setFMes(''); setFLinea(''); setFArea(''); setFTurno('');
  }

  function exportarExcel() {
    const filas = registros.map((r) => ({
      Fecha: new Date(r.fecha).toLocaleDateString('es-MX'),
      Línea: r.linea,
      Área: r.area,
      Turno: r.turno,
      'Horas Planeadas': parseFloat(r.horas_planeadas).toFixed(2),
      'Horas de Paro': parseFloat(r.tiempo_paro_horas).toFixed(2),
      '% Tiempo Muerto': r.pct_tiempo_muerto.toFixed(2),
    }));
    const ws = XLSX.utils.json_to_sheet(filas);
    ws['!cols'] = [{ wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 16 }, { wch: 14 }, { wch: 14 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Tiempo Muerto');
    XLSX.writeFile(wb, `dasavena_tiempo_muerto_${new Date().toISOString().slice(0, 10)}.xlsx`);
  }

  const totalParoHoras = registros.reduce((s, r) => s + parseFloat(r.tiempo_paro_horas), 0);
  const totalPlaneadasHoras = registros.reduce((s, r) => s + parseFloat(r.horas_planeadas), 0);
  const pctGlobal = totalPlaneadasHoras > 0 ? (totalParoHoras / totalPlaneadasHoras) * 100 : 0;
  const semaforo = pctGlobal <= META ? '#3E7C5A' : pctGlobal <= META * 3 ? '#C08A2B' : '#B23A48';

  return (
    <div style={styles.paginaContenedor}>
      <div style={styles.headerFila}>
        <div>
          <h1 style={styles.tituloPagina}>Tiempo Muerto</h1>
          <p style={styles.subtituloPagina}>% Tiempo Muerto = Horas Detenidas ÷ Horas Planeadas del turno · Meta: &lt;{META}%</p>
        </div>
        <button onClick={exportarExcel} disabled={registros.length === 0} style={styles.botonExcel}>⬇ Descargar Excel</button>
      </div>

      <div style={styles.kgrid}>
        <div style={{ ...styles.kcard, borderTop: `3px solid ${semaforo}` }}>
          <div style={styles.kLbl}>% Tiempo Muerto</div>
          <div style={{ ...styles.kVal, color: semaforo }}>{pctGlobal.toFixed(2)}%</div>
          <div style={styles.kSub}>meta: &lt;{META}%</div>
        </div>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Horas de Paro</div>
          <div style={styles.kVal}>{totalParoHoras.toFixed(1)} hrs</div>
        </div>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Horas Planeadas</div>
          <div style={styles.kVal}>{totalPlaneadasHoras.toFixed(1)} hrs</div>
        </div>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Turnos evaluados</div>
          <div style={styles.kVal}>{registros.length}</div>
        </div>
      </div>

      {topCausas.length > 0 && (
        <div style={styles.causasCard}>
          <div style={styles.causasTitulo}>Top 5 causas de paro</div>
          <div style={styles.causasLista}>
            {topCausas.map((c, i) => (
              <div key={i} style={styles.causaFila}>
                <span style={styles.causaDesc}>{c.descripcion}</span>
                <span style={styles.causaHoras}>{parseFloat(c.horas_total).toFixed(1)} hrs</span>
                <span style={styles.causaOcurrencias}>{c.ocurrencias}x</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={styles.filtrosBar}>
        <FiltroFecha label="Desde" value={fDesde} onChange={(v) => { setFDesde(v); setFMes(''); }} />
        <FiltroFecha label="Hasta" value={fHasta} onChange={(v) => { setFHasta(v); setFMes(''); }} />
        <FiltroSel label="Mes" value={fMes} onChange={handleMesChange} options={[['', '—'], ...MESES]} />
        <div style={styles.filtroGrupo}>
          <label style={styles.filtroLabel}>Año</label>
          <input type="number" value={fAnio} onChange={(e) => setFAnio(e.target.value)} style={{ ...styles.filtroInput, width: '80px' }} />
        </div>
        <FiltroSel label="Línea" value={fLinea} onChange={setFLinea} options={[['', 'Todas'], ...LINEAS.map((l) => [l, l])]} />
        <FiltroSel label="Área" value={fArea} onChange={setFArea} options={[['', 'Todas'], ...AREAS.map((a) => [a, a])]} />
        <FiltroSel label="Turno" value={fTurno} onChange={setFTurno} options={[['', 'Todos'], ...TURNOS.map((t) => [t, t])]} />
        <button onClick={cargar} style={styles.botonBuscar2}>Buscar</button>
        <button onClick={limpiarFiltros} style={styles.botonLimpiar}>Limpiar</button>
      </div>

      {cargando ? <div>Cargando...</div> : error ? <div style={{ color: '#B23A48' }}>{error}</div> : (
        <div style={styles.tablaScroll}>
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Fecha</th><th style={styles.th}>Línea</th><th style={styles.th}>Área</th>
                <th style={styles.th}>Turno</th><th style={styles.th}>Horas Planeadas</th>
                <th style={styles.th}>Horas de Paro</th><th style={styles.th}>% Tiempo Muerto</th>
              </tr>
            </thead>
            <tbody>
              {registros.map((r) => {
                const color = r.pct_tiempo_muerto <= META ? '#3E7C5A' : r.pct_tiempo_muerto <= META * 3 ? '#C08A2B' : '#B23A48';
                return (
                  <tr key={r.id}>
                    <td style={styles.td}>{new Date(r.fecha).toLocaleDateString('es-MX')}</td>
                    <td style={styles.td}>{r.linea}</td>
                    <td style={styles.td}>{r.area}</td>
                    <td style={styles.td}>{r.turno}</td>
                    <td style={styles.td}>{parseFloat(r.horas_planeadas).toFixed(2)}</td>
                    <td style={styles.td}>{parseFloat(r.tiempo_paro_horas).toFixed(2)}</td>
                    <td style={{ ...styles.td, fontWeight: 700, color }}>{r.pct_tiempo_muerto.toFixed(2)}%</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {registros.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>Sin registros para este filtro.</p>}
        </div>
      )}
    </div>
  );
}

function FiltroSel({ label, value, onChange, options }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}
function FiltroFecha({ label, value, onChange }) {
  return (
    <div style={styles.filtroGrupo}>
      <label style={styles.filtroLabel}>{label}</label>
      <input type="date" value={value} onChange={(e) => onChange(e.target.value)} style={styles.filtroInput} />
    </div>
  );
}

const styles = {
  paginaContenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42' },
  headerFila: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '14px', marginBottom: '4px' },
  botonExcel: { padding: '8px 16px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#3E7C5A', border: 'none', borderRadius: '8px', cursor: 'pointer', flexShrink: 0 },
  tituloPagina: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtituloPagina: { fontSize: '12px', color: '#8A7690', marginBottom: '16px' },
  kgrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '14px', marginBottom: '14px' },
  kcard: { background: '#fff', border: '1px solid #E6DDD2', borderTop: '3px solid #4A1E5C', borderRadius: '12px', padding: '16px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  kLbl: { fontSize: '11px', fontWeight: 500, color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '8px' },
  kVal: { fontSize: '24px', fontWeight: 700, color: '#2A1830' },
  kSub: { fontSize: '11px', color: '#8A7690', marginTop: '4px' },
  causasCard: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '16px', marginBottom: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  causasTitulo: { fontSize: '12px', fontWeight: 700, color: '#2A1830', marginBottom: '10px' },
  causasLista: { display: 'flex', flexDirection: 'column', gap: '6px' },
  causaFila: { display: 'flex', alignItems: 'center', gap: '12px', fontSize: '12px', padding: '6px 10px', background: '#FAF6F0', borderRadius: '6px' },
  causaDesc: { flex: 1, color: '#3A2E42' },
  causaHoras: { fontWeight: 700, color: '#4A1E5C' },
  causaOcurrencias: { color: '#8A7690', fontSize: '11px' },
  filtrosBar: { display: 'flex', alignItems: 'flex-end', gap: '12px', flexWrap: 'wrap', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', padding: '14px 16px', marginBottom: '10px' },
  filtroGrupo: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filtroLabel: { fontSize: '10px', color: '#8A7690', textTransform: 'uppercase', letterSpacing: '0.4px' },
  filtroInput: { padding: '6px 8px', fontSize: '12px', border: '1px solid #E6DDD2', borderRadius: '6px', fontFamily: 'Inter, sans-serif' },
  botonBuscar2: { padding: '7px 16px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#4A1E5C', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  botonLimpiar: { padding: '7px 14px', fontSize: '12px', color: '#8A7690', background: 'transparent', border: '1px solid #E6DDD2', borderRadius: '6px', cursor: 'pointer' },
  tablaScroll: { overflowX: 'auto', background: '#fff', border: '1px solid #E6DDD2', borderRadius: '10px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '2px solid #E6DDD2', color: '#6E4F80', fontWeight: 600, fontSize: '11px', textTransform: 'uppercase', whiteSpace: 'nowrap' },
  td: { padding: '6px 10px', borderBottom: '1px solid #F0E9E0', whiteSpace: 'nowrap' },
};